import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-add',
	path: '/secure/admin/AddNewFieldScreen.jspa',
};
